<template>
  <Teleport to="#notification-area">
    <Transition
      enter-active-class="transform ease-out duration-300 transition"
      enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="true"
        class="pointer-events-auto relative w-full max-w-sm overflow-hidden rounded-lg bg-background text-background-fg shadow-lg ring-1 ring-black/5"
      >
        <div class="p-4">
          <div class="flex items-center">
            <div
              class="flex shrink-0 items-center justify-center"
            >
              <template v-if="type === 'success'">
                <IconCheckCircle
                  class="size-6 text-positive"
                  aria-hidden="true"
                />
              </template>

              <template v-else-if="type === 'error'">
                <IconExclamationTriangle
                  class="size-6 text-error"
                  aria-hidden="true"
                />
              </template>

              <template v-else-if="type === 'info'">
                <IconInfo
                  class="size-6 text-info"
                  aria-hidden="true"
                />
              </template>
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm">
                {{ message }}
              </p>
            </div>
            <div class="ml-4 flex shrink-0">
              <button
                type="button"
                class="inline-flex rounded-md"
                @click="emit('close')"
              >
                <span class="sr-only">Close</span>
                <IconX class="size-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div
          :class="[
            $style.progressBar,
            type === 'success'
              ? 'bg-positive'
              : type === 'error'
                ? 'bg-error'
                : 'bg-info',
            'absolute inset-x-0 bottom-0 h-[2px] rounded-full',
          ]"
          :style="{ '--duration': timeout }"
        >
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
type Props = {
  message?: string
  type?: "success" | "error" | "info"
  timeout?: number
}

const props = withDefaults(defineProps<Props>(), {
  message: "",
  type: "success",
  timeout: 1500,
})

const emit = defineEmits(["close"])

onMounted(() => {
  if (props.timeout) {
    setTimeout(() => {
      destroySelf()
    }, props.timeout)
  }
})

const destroySelf = () => emit("close")
</script>

<style lang="scss" module>
.progressBar {
  transform-origin: left center;
  animation: roundtime calc(var(--duration) * 1ms) linear
    forwards;
}

@keyframes roundtime {
  to {
    /* More performant than animating `width` */
    transform: scaleX(0);
  }
}
</style>
